import { createBrowserRouter, Outlet, type RouteObject } from 'react-router-dom';

import { Chrome } from './components/chrome/Chrome';
import { MinimalChrome } from './components/chrome/MinimalChrome';
import About from './pages/About';
import AdminApp from './pages/admin/AdminApp';
import Article from './pages/Article';
import Dashboard from './pages/Dashboard';
import Docs from './pages/Docs';
import Home from './pages/Home';
import Login from './pages/Login';
import Marketplace from './pages/Marketplace';
import NotFound from './pages/NotFound';
import Performance from './pages/Performance';
import Pricing from './pages/Pricing';
import Research from './pages/Research';
import Signup from './pages/Signup';
import Strategy from './pages/Strategy';

const routes: RouteObject[] = [
  {
    element: (
      <Chrome>
        <Outlet />
      </Chrome>
    ),
    errorElement: <NotFound />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/strategies', element: <Marketplace /> },
      { path: '/strategies/:id', element: <Strategy /> },
      { path: '/performance', element: <Performance /> },
      { path: '/research', element: <Research /> },
      { path: '/research/:id', element: <Article /> },
      { path: '/pricing', element: <Pricing /> },
      { path: '/about', element: <About /> },
      { path: '/docs', element: <Docs /> },
      { path: '/dashboard', element: <Dashboard /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    element: (
      <MinimalChrome>
        <Outlet />
      </MinimalChrome>
    ),
    errorElement: <NotFound />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/signup', element: <Signup /> },
    ],
  },
  ...(import.meta.env.DEV
    ? [
        {
          path: '/admin/*',
          element: <AdminApp />,
        },
      ]
    : []),
];

export const router = createBrowserRouter(routes);
